import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import LoaderScreen from "../Pages/LoaderScreen";
import { getAuthUserAction } from "../Store/Actions/AuthActions";

const AuthRoute = ({ component: Component }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const loginCheck = () => {
    getAuthUserAction(dispatch)
      .then((res) => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loginCheck();
  }, []);

  if (!loading && isAuthenticated) {
    return <Component />;
  } else if (!loading && !isAuthenticated) {
    return <Navigate to="/login" />;
  } else {
    return <LoaderScreen />;
  }
};

export default AuthRoute;
